import _ from 'underscore';

function fallbackCopyTextToClipboard(text) {
	const textArea = document.createElement('textarea');
	textArea.value = text;

	// Avoid scrolling to bottom
	textArea.style.top = '0';
	textArea.style.left = '0';
	textArea.style.position = 'fixed';

	document.body.appendChild(textArea);
	textArea.focus();
	textArea.select();

	try {
		const successful = document.execCommand('copy');
		const msg = successful ? 'successful' : 'unsuccessful';
		console.log(`Fallback: Copying text command was ${msg}`);
	} catch (error) {
		console.error('Fallback: Oops, unable to copy', error);
	}

	document.body.removeChild(textArea);
}

// Скопировать текст
export function copyTextToClipboard(text) {
	if (!navigator.clipboard) {
		fallbackCopyTextToClipboard(text);
	} else {
		navigator.clipboard.writeText(text).then(
			function () {
				console.log('Async: Copying to clipboard was successful!');
			},
			function (error) {
				fallbackCopyTextToClipboard(text);
				console.error('Async: Could not copy text: ', error);
			},
		);
	}
}

// Проверить наличие класса у элемента
export function hasClass(el, cls) {
	if (!el || !cls) return false;
	if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
	if (el.classList) {
		return el.classList.contains(cls);
	}

	return ` ${el.className} `.indexOf(` ${cls} `) > -1;
}

// Добавить класс у элемента
export function addClass(el, cls) {
	if (!el) return;
	let curClass = el.className;
	const classes = (cls || '').split(' ');

	for (let i = 0, j = classes.length; i < j; i++) {
		const clsName = classes[i];
		if (!clsName) continue;

		if (el.classList) {
			el.classList.add(clsName);
		} else if (!hasClass(el, clsName)) {
			curClass += ` ${clsName}`;
		}
	}
	if (!el.classList) {
		el.className = curClass;
	}
}

// Удалить класс у элемента
export function removeClass(el, cls) {
	if (!el || !cls) return;
	const classes = cls.split(' ');
	let curClass = ` ${el.className} `;

	for (let i = 0, j = classes.length; i < j; i++) {
		const clsName = classes[i];
		if (!clsName) continue;

		if (el.classList) {
			el.classList.remove(clsName);
		} else if (hasClass(el, clsName)) {
			curClass = curClass.replace(` ${clsName} `, ' ');
		}
	}
	if (!el.classList) {
		el.className = curClass;
	}
}

// Проверить наличие свойств в обьекте
/** @deprecated не вижу смысла в этом методе */
export const has = (obj, key) => {
	let objInternal = obj;
	const args = key.split('.');
	for (let i = 0; i < args.length; i++) {
		if (!objInternal || !Object.hasOwn(objInternal, args[i])) {
			return false;
		}
		objInternal = objInternal[args[i]];
	}

	return true;
};

/**
 * Достанет чистое значение из полей АРМ по имени, вернет undefined если не удалось
 * @param {any[]} fields массив полей как с dbcolname, так и с fieldId. Тип на самом деле - CardMetaItem[] | ListMetaItem[] | UarmRecordField[]
 * @param {string} fname имя поля арм (fieldId/dbcolname)
 * @returns { string | number | null | undefined }
 */
export function getFieldValue(fields, fname) {
	if (!Array.isArray(fields)) return undefined;
	const field = fields.find((f) => f.fieldId === fname || f.dbcolname === fname);
	if (!field) return undefined;

	return field.rawValue || field.value;
}

export const unescapeSpecialChars = (value) => {
	return _.unescape(value);
};

export const generateUUID = () => {
	return 'xxxxxxxx-xxxx-4xxx'.replace(/[xy]/g, function (c) {
		const r = (Math.random() * 16) | 0;
		const v = c === 'x' ? r : (r & 0x3) | 0x8;

		return v.toString(16);
	});
};

export const humanFileSize = (size) => {
	if (size >= 2048) {
		return `${Math.ceil(size / 1000)} МБ`;
	}

	return `${size} кБ`;
};

// export const isWizard = typeof process === 'object' && process.versions && process.versions['electron'];
// версия выше не работает с nodeIntegration=false
export const isWizard = typeof navigator === 'object' && navigator.userAgent.toLowerCase().includes(' metawizard/');

export const isLocalDomain =
	typeof location !== 'undefined' &&
	location.host.split('.')[1] === 'local' &&
	location.host.split('.')[2] === 'oooinex';

export const orderComparator = (a, b) => {
	const aOrder = a ? a.order : 0;
	const bOrder = b ? b.order : 0;

	return aOrder - bOrder;
};

export const nameComparator = (a, b) => {
	if (a.name > b.name) {
		return 1;
	}

	if (a.name < b.name) {
		return -1;
	}

	return 0;
};

/**
 * Функция для emptyValueDisplayProps. Поля с пустыми значениями либо убираем целиком, либо, если задан плейсхолдером - выводим его (CWP-20177)
 * @param {boolean} isNewRecord
 * @param {import('./types').Pojo} ctrlParams
 * @param {any} value
 * @returns
 */
export function getEmptyValueDisplay(isNewRecord, ctrlParams, value) {
	/** -- ломает сборку визарда!  --@ type {import('./types').EmptyValueDisplayProps} */
	const EVDP = ctrlParams && ctrlParams.emptyValueDisplayProps;
	const valueEmpty = value === null || value === '' || value === false || value === undefined;
	const active = !isNewRecord && EVDP && EVDP.enabled && valueEmpty;
	const text = EVDP && EVDP.placeholderText;

	return {
		text,
		color: (EVDP && EVDP.placeholderColor) || '#000',
		active,
		needToHide: active && !text,
	};
}

/*
	иницилизация Observer
	следит за переключателем смены темы и прокидывает класс внутрь iframe
 */
export function initWatchToChangeTheme(body) {
	if (!body) return;

	new MutationObserver(() => {
		if (body.classList.contains('v-theme--light')) {
			body.classList.add('v-theme--dark');
			body.classList.remove('v-theme--light');
		} else {
			body.classList.remove('v-theme--dark');
			body.classList.add('v-theme--light');
		}
	}).observe(document.querySelector('.v-application'), { attributes: true });
}
